import { Component, Input } from '@angular/core';
import { NdmsSafeSubscriber } from '../../../../../../../shared/core/interfaces/ndms-safe-subscriber';

@Component({
  selector: 'ui-checkmark',
  templateUrl: './ui-checkmark.component.html',
  styleUrls: ['./ui-checkmark.component.scss']
})
export class UiCheckmarkComponent extends NdmsSafeSubscriber {
  @Input() checked: boolean;
}
